import {api as com, apiFuns } from 'sw-hic'

const api = {
  /** ****************** 患者 ****************** **/
  getOrCreatePatientByIdInfo: com.getOrCreatePatientByIdInfo,
  getOrCreatePatientByInsurance: com.getOrCreatePatientByInsurance,
  /** ****************** 读卡 ****************** **/
  readIdCard() {
    return new Promise((resolve, reject) => {
      com.getPatientByIdNo('110105196802116116').then(res => {
        resolve(res)
      })
    })
  },
  readInsuranceCard() {
    return new Promise((resolve, reject) => {
      com.getPatientByIdNo('110105197402126126').then(res => {
        resolve(res)
      })
    })
  },
  readInsuranceCardInjury() {
    return new Promise((resolve, reject) => {
      com.getPatientByIdNo('110105197002116116').then(res => {
        res.injuries = [
          {
            id: 112255,
            time: '2020-12-25',
            proces: '工作时跌倒',
            partordisease: '左膝粉碎性骨折'
          }, {
            id: 112659,
            time: '2020-12-25',
            proces: '工作时跌倒',
            partordisease: '右膝粉碎性骨折'
          },
        ]
        resolve(res)
      })
    })
  },
  //根据患者ID取得入院登记信息
  getAdmission:pid =>{
    return apiFuns.get(`/api/ip/hospitalization`,{patientCode:pid});
  },
  
  //根据ID取得床位
  getBedById: id => {
    return get(`/api/ip/bed/${id}`);
  },
  //根据ID取得患者信息
  getPatient: id => {
    return get(`/api/md/patient/${id}`);
  },
  //通过患者的住院号获取所有包床信息。
  listByIpNo: ipNo => {
    return get(`/api/ip/bedLog/listByIpNo/${ipNo}`);
  },
  //获取包床
  cancelWrappe:ipNo =>{
    return put(`/api/ip/bed/cancelWrappe/${ipNo}`);
  },
  //添加押金
  addDeposit: para => {
    return post("/api/ip/deposit", para);
  },
  //添加打印次数
  paymentCounts:id =>{
    return put(`/api/ip/deposit/print/${id}`);
  },

  
    /** **********5级地址联动****************** **/

    getIdRegionInfo:(id)=>{
      return get(`/md/regionInfo/${id}`);
    },
  
    queryRegionInfo:(para)=>{
      return get(`/api/md/regionInfo`, para);
    },
  
  //   queryRegionInfoFirstNest:()=>{
  //     return get(`/api/md/regionInfo/getNest`);
  //   },
  
   getRegionInfoNest:(para)=>{
      return get(`/api/md/regionInfo/getNest`, para || {});
   },
   
   queryAddress: code=>{
    return get(`/api/md/regionInfo/allPath`,{regionCode: code,tenantId: 0})
   }
}

export default api
